import { render, staticRenderFns } from "./signup_th.vue?vue&type=template&id=4c0a0bcd&"
import script from "./signup_th.vue?vue&type=script&lang=js&"
export * from "./signup_th.vue?vue&type=script&lang=js&"
import style0 from "./signup_th.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports